import { DefaultError, useMutation } from "@tanstack/react-query";
import {
  generateAIPageModule,
  GenerateAIPageModuleResponse,
} from "../api/generateAIPageModule";
import { invalidateModuleListByBrandPageQuery } from "../queries/useModuleListByBrandPageQuery";
import { invalidatePagesListByBrandsQuery } from "../queries/usePagesListByBrandQuery";

type Params = {
  brandId: string;
  pageId: string;
  prompt: string;
  order?: number;
};

export const useGenerateAndAddAIModuleMutation = () => {
  return useMutation<GenerateAIPageModuleResponse, DefaultError, Params>({
    mutationFn: async (params) => {
      const data = await generateAIPageModule(params);

      if (data.error) {
        throw new Error(data.error);
      }

      return data;
    },
    onSuccess: async (data, params) => {
      invalidateModuleListByBrandPageQuery(params.brandId, params.pageId);

      // invalidate query in 3 seconds
      setTimeout(() => {
        invalidatePagesListByBrandsQuery(params.brandId);
      }, 3000);

      // when streaming is implemented, we can use this to create the module in the backend as it will not be created during n8n flow
      // await createAIGeneratedModule({
      //   brandId: params.brandId,
      //   pageId: params.pageId,
      //   order: params.order,
      //   moduleName: data.moduleName,
      //   games: data.games,
      // });
    },
    onError: (e) => {
      console.error("Error occurred when creating module", e);
    },
  });
};
